module.exports = __webpack_public_path__ + "img/map_for_franchise_kaz.3bd0562f.png";